var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ServiceLayout',{attrs:{"icon":"notext-starpick.png","title":"Starpick","description":"Layanan antar jemput oleh Guiders menggunakan transportasi publik ke bandara, stasiun, hitel atau tempat anda menginap.","extra_hour":null,"tariffs":_vm.starpick_tariffs,"lists":_vm.starpick_list}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6db80f8c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Service/StarPick.vue
// module id = null
// module chunks = 